import React from 'react'

import $ from 'jquery'

import Footer from 'app/agency/stocklist/components/footer'
import Header from 'app/agency/stocklist/components/header'
import Layout from 'app/agency/stocklist/components/layout'
import PropertyFilter from 'app/agency/stocklist/components/PropertyFilter'
import { Box, Flex } from 'app/components/design-system-components'
import { Button } from 'app/components/design-system-components/Button'
import { ErrorMessage } from 'app/shared_components/helpers'

import 'app/agency/stocklist/index.scss'

class Stocklist extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      agencyDetails: {},
      properties: [],
      propertyTypeFilter: {},
    }
  }

  componentDidMount() {
    const {
      match: {
        params: { agencySlug },
      },
      fetchStocklist,
    } = this.props
    $('#index').addClass('no-navbar-menu')
    fetchStocklist(agencySlug)
      .then((responseData) => {
        this.setState({
          agencyDetails: responseData.agencyDetails,
          properties: responseData.listedProperties || [],
        })
      })
      .catch((error) => {
        this.setState({ error })
      })
  }

  componentWillUnmount() {
    $('#index').removeClass('no-navbar-menu')
  }

  handlePropertyTypeFilterChange = (newPropertyTypeFilter) => {
    this.setState({ propertyTypeFilter: newPropertyTypeFilter })
  }

  handlePrint = () => {
    window.print()
  }

  getFilteredProperties = () => {
    const { properties, propertyTypeFilter } = this.state

    if (Object.keys(propertyTypeFilter).length === 0) {
      return properties
    }

    return properties.filter((property) => {
      const propertyType = property.type
      const filterKey = Object.keys(propertyTypeFilter).find(
        (key) =>
          String(key).toLowerCase() === String(propertyType).toLowerCase(),
      )
      return filterKey && propertyTypeFilter[filterKey]
    })
  }

  render() {
    const { agencyDetails, propertyTypeFilter } = this.state
    const {
      match: {
        params: { agencySlug },
      },
    } = this.props
    const { error } = this.state
    const filteredProperties = this.getFilteredProperties()

    return (
      <Box>
        {!error && (
          <Box className="stocklist-container">
            <Flex
              justifyContent="center"
              alignItems="center"
              p="20px 0"
              mb="20px"
              borderBottom="1px solid #e0e0e0"
              className="pdf-hide"
            >
              <Flex alignItems="center" gap="10px" pr="20px">
                <PropertyFilter
                  properties={this.state.properties}
                  propertyTypeFilter={propertyTypeFilter}
                  onFilterChange={this.handlePropertyTypeFilterChange}
                />
              </Flex>
              <Flex alignItems="center">
                <Button variant="primary" onClick={this.handlePrint}>
                  Print Stocklist
                </Button>
              </Flex>
            </Flex>
            <Header />
            <Box as="main" className="main-content">
              <Layout
                teamSlug={agencySlug}
                agencyDetails={agencyDetails}
                properties={filteredProperties}
              />
            </Box>
            <Footer teamSlug={agencySlug} agencyDetails={agencyDetails} />
          </Box>
        )}
        <ErrorMessage error={error} />
      </Box>
    )
  }
}

export default Stocklist
